/** 侧栏菜单（与数据库 sys_menu 结构一致，用于展示与兜底） */
export const sidebarMenus = [
  {
    path: '/home',
    meta: { title: '首页', icon: 'el-icon-s-home' },
    children: [
      { path: 'overview', meta: { title: '概览' } },
      { path: 'map', meta: { title: '地图' } }
    ]
  },
  {
    path: '/device',
    meta: { title: '设备管理', icon: 'el-icon-cpu' },
    children: [
      { path: 'list', meta: { title: '设备列表' } },
      { path: 'site', meta: { title: '站点列表' }, component: 'device/site/index' },
      { path: 'type', meta: { title: '设备类型' } },
      { path: 'project-category', meta: { title: '项目分类' }, component: 'device/projectCategory/index' },
      { path: 'monitor', meta: { title: '设备监控' }, component: 'terminal/monitor/index' },
      { path: 'message', meta: { title: '通信报文' }, component: 'terminal/message/index' },
      { path: 'trend', meta: { title: '趋势图' }, component: 'device/trend/index' },
      { path: 'stats', meta: { title: '设备统计' }, component: 'terminal/stats/index' },
      { path: 'recycle', meta: { title: '回收站' }, component: 'device/recycle/index' },
    ]
  },
  {
    path: '/report',
    meta: { title: '报表管理', icon: 'el-icon-document' },
    children: [
      { path: 'daily', meta: { title: '日报表' } },
      { path: 'monthly', meta: { title: '月报表' } },
      { path: 'yearly', meta: { title: '年报表' } },
      { path: 'custom', meta: { title: '自定义报表' } },
      { path: 'usage', meta: { title: '用量统计报表' } }
    ]
  },
  {
    path: '/alarm',
    meta: { title: '告警管理', icon: 'el-icon-bell' },
    children: [
      { path: 'realtime', meta: { title: '实时告警' } },
      { path: 'history', meta: { title: '历史告警' } },
      { path: 'settings', meta: { title: '告警设置' } }
    ]
  },
  {
    path: '/iot',
    meta: { title: '物联网卡管理', icon: 'el-icon-mobile-phone' },
    children: [{ path: 'card', meta: { title: '物联网卡列表' } }]
  },
  {
    path: '/org',
    meta: { title: '组织管理', icon: 'el-icon-office-building' },
    children: [
      { path: 'list', meta: { title: '组织列表' } }
    ]
  },
  {
    path: '/user',
    meta: { title: '用户管理', icon: 'el-icon-user' },
    children: [
      { path: 'list', meta: { title: '用户列表' }, component: 'system/user/index' },
      { path: 'role', meta: { title: '角色权限' }, component: 'system/role/index' }
    ]
  },
  {
    path: '/protocol',
    meta: { title: '燃气协议管理', icon: 'el-icon-connection' },
    children: [
      { path: 'list', meta: { title: '协议解析管理' } }
    ]
  },
  {
    path: '/system',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      { path: 'basic', meta: { title: '基础设置' } },
      { path: 'backup', meta: { title: '数据库备份' } },
      { path: 'log', meta: { title: '操作日志' } },
      { path: 'menu', meta: { title: '菜单管理' }, component: 'system/menu/index' }
    ]
  }
]

export function resolveMenuComponent(parentPath, child) {
  if (child.component) return child.component
  const segment = parentPath.replace(/^\//, '')
  return `${segment}/${child.path}/index`
}

export function menuIndex(parentPath, childPath) {
  return `${parentPath}/${childPath}`
}
